// Hooks
import { useMutation } from '@tanstack/react-query';
import { useSearchParams } from 'react-router-dom';
import { useFeatures, getEnabledFeatures } from '../../hooks/features';
import { getClient } from '../../utils/getClient';

// Types
import { UpdateAmbassadorRequest } from '@amzn/red-velvet-api';

const MUTATION_PREFIX = ['RedVelvetApi', 'ambassadors'];

export function useUpdateAmbassador() {
  const features = useFeatures();
  const [searchParams] = useSearchParams();
  const client = getClient(getEnabledFeatures(features, searchParams));

  return useMutation({
    mutationKey: MUTATION_PREFIX.concat(['updateAmbassador']),
    mutationFn: async (request: UpdateAmbassadorRequest) => {
      const result = await client.updateAmbassador(request);

      return {
        result,
      };
    },
    onSuccess: (data) => {
      return data;
    },
  });
}
